var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfodifetti2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_20763",
    "data-name": "Raggruppa 20763",
    transform: "translate(-987 1960)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_10947",
    "data-name": "Rettangolo 10947",
    width: 23,
    height: 23,
    rx: 3,
    transform: "translate(987 -1960)",
    fill: "#3260ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-flash",
    "data-name": "Icon ionic-ios-flash",
    d: "M16,7.664H12.947l1.478-5.272a.114.114,0,0,0-.2-.1L9.04,9.091a.238.238,0,0,0,.178.378H12.27l-1.478,5.272a.114.114,0,0,0,.2.1l5.182-6.793A.241.241,0,0,0,16,7.664Z",
    transform: "translate(986.004 -1957.245)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfodifetti2);
export default __webpack_public_path__ + "static/media/infodifetti2.99d6e66c33af19ef7cd478459b6563db.svg";
export { ForwardRef as ReactComponent };